import api from '@/services/ledgerFilter'
export default {
  namespaced: true,
  state: {
      banknames: null,
      rem: null
  },
  getters: {

  },
  mutations: {
    fetchBank(state, banknames) {
        state.banknames= banknames
    },
    fetchRemember(state, rem) {
      state.rem = rem.name
     
    },
    saveRemember(state, rem) {
      state.rem = rem
    }
  },
  actions: {
    async fetchBank(context, data) {
        const banknames = (await api.fetchBank(data)).data
        await context.commit('fetchBank', banknames) 
    },

    async saveRemember(context, data) {
      await api.saveRemember(data)
      context.commit('saveRemember', data)
      
    },

    async fetchRemember(context, data) {
      const rem = await api.fetchRemember()
      
      context.commit('fetchRemember', rem[0])
    }
  }
}
